import { Contact } from "@/data/schemas";
import {
  contactPrimaryLabel as coreContactPrimaryLabel,
  contactSecondaryLabel as coreContactSecondaryLabel,
} from "@/core_bridge/switch-core";

export type ContactStatusFlags = {
  isBlocked: boolean;
  isMuted: boolean;
};

// Contact-label formatting lives in core (`display_name.rs`, exposed via WASM)
// so web/iOS/Android render identically. Do not reimplement the fallback logic
// here — extend it in core.
const fullHandleOf = (user: Contact): string =>
  (user.fullHandle ?? (user as any).full_handle ?? "").toString().trim();

export const contactPrimaryLabel = (user: Contact): string =>
  coreContactPrimaryLabel(
    fullHandleOf(user),
    user.username,
    user.discriminator,
    user.deviceId,
    user.userId
  );

export const contactSecondaryLabel = (user: Contact): string =>
  coreContactSecondaryLabel(
    fullHandleOf(user),
    user.username,
    user.discriminator,
    user.deviceId,
    user.userId
  );

export const contactUpdatedAtValue = (user: Contact): number => {
  return user.updatedAt ?? 0;
};

export const contactStatusFlags = (user: Contact): ContactStatusFlags => {
  return {
    isBlocked: !!user.isBlocked,
    isMuted: !!user.isMuted,
  };
};

export const normalizeContacts = (
  contacts: Contact[] | null | undefined,
  currentUserId?: string,
): Contact[] => {
  const safeContacts = Array.isArray(contacts) ? contacts : [];
  return safeContacts
    .filter((contact) => !currentUserId || contact.userId !== currentUserId)
    .slice()
    .sort((a, b) => {
      const aUpdated = contactUpdatedAtValue(a);
      const bUpdated = contactUpdatedAtValue(b);
      if (aUpdated !== bUpdated) return bUpdated - aUpdated;
      return (a.userId || "").localeCompare(b.userId || "");
    });
};
